<template>
    <div id="cust_component" class="component_body">
        <headerComponent title = "Link Sent Successfully" />   
         <div class="container-fluid">
            <div class="row">
                <div class="col-11 mail_div m-auto">
                    <div class='row'>
                        <div class='col-11 m-auto'> 
                            <div class='text-center'>
                                <img src="../../assets/customer/images/mail_sent_icon.svg">
                                <h4 class='mt-5'><b>Link Sent Successfully</b></h4>
                                <h6 class=' m-0 ash text-break font-18'>Password reset link has been sent to your email, please set your new password from that link.</h6>
                                <p class='ash text-break mt-3 mb-0' style='font-size:14px;'>Can't find it? Search your email for <b>BookJoy</b> and check your <b>Spam/Junk</b> folder.</p>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>
         </div>
    
    </div>       
</template>
<style scoped>

.mail_div{
    max-width: 350px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

</style>

<script>

import headerComponent from '@/components/cust_components/cust_header_component.vue';
  
    export default {
      name: 'mailSent',
        data() {
          return {
            mobile_view : false,
          }
        },
        components: {     
            headerComponent,
        },
        mounted(){
            this.responsive_view();
            window.addEventListener('resize', this.responsive_view);
        },
        methods:{
            async responsive_view(){

                await this.$store.commit('responsive_view', window.innerWidth)
            
            },
        }
    }
</script>
